import { createSlice } from '@reduxjs/toolkit'

// Define the type of the state
interface SignInState {
  signedIn: boolean;
  token: string | null;
}

// Define the initial state
const initialState: SignInState = {
  signedIn: false,
  token: null,
};

export const signInSlice = createSlice({
  name: 'signedIn',
  initialState: initialState,
  reducers: {
    signedIn: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes.
      // Also, no return statement is required from these functions.
      state.signedIn = true;
    },
    signedOut: (state) => {
      state.signedIn = false;
    },
    storeToken: (state, actions) => {
      state.token = actions.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { signedIn, signedOut, storeToken } = signInSlice.actions

export default signInSlice.reducer
